import * as React from 'react'
import styled from 'styled-components'

import { toCurrency } from '@espoon-voltti/ts-libs/lib/euro'

import { Section } from '@espoon-voltti/react-components/layout'
import { Title } from '@espoon-voltti/react-components/elements'

import { LabelValueList } from '@espoon-voltti/react-voltti/components/label-value-list'

import { AgeDistribution } from '@espoon-voltti/nuora-domain/grants'

import { ProjectGrantFormData } from '../../../domain'
import { t } from '../../../i18n'

const Spacer = styled.div`
  margin-top: 40px;
`

interface Props {
  form: ProjectGrantFormData
}

export const AppDetails: React.FC<Props> = (p) => {
  return (
    <Section>
      <LabelValueList
        dataQa={'n/a'}
        values={[
          {
            dataQa: 'eventName',
            label: t(['views', 'form', 'appDetails', 'event', 'name']),
            value: p.form.event.name
          },
          {
            dataQa: 'eventLocation',
            label: t(['views', 'form', 'appDetails', 'event', 'location']),
            value: p.form.event.location
          },
          {
            dataQa: 'eventStartDate',
            label: t(['views', 'form', 'appDetails', 'event', 'startDate']),
            value: p.form.event.startDate?.format('fi')
          },
          {
            dataQa: 'eventEndDate',
            label: t(['views', 'form', 'appDetails', 'event', 'endDate']),
            value: p.form.event.endDate?.format('fi')
          },
          {
            dataQa: 'purpose',
            label: t(['views', 'form', 'appDetails', 'purpose']),
            value: p.form.purpose
          },
          {
            dataQa: 'purpose',
            label: t(['views', 'form', 'appDetails', 'appliedTotal']),
            value: toCurrency(p.form.appliedSum)
          }
        ]}
      />

      <Spacer />

      <Title size={3}>
        {t(['views', 'form', 'appDetails', 'numberOfParticipants'])}
      </Title>
      <LabelValueList
        dataQa={'n/a'}
        values={[
          {
            dataQa: 'participantsAges7to20',
            label: t([
              'views',
              'form',
              'appDetails',
              'participants',
              'ages7to20',
              'label'
            ]),
            value: p.form.participants.ages7to20
          },
          {
            dataQa: 'participantsAges21to28',
            label: t([
              'views',
              'form',
              'appDetails',
              'participants',
              'ages21to28',
              'label'
            ]),
            value: p.form.participants.ages21to28
          },
          {
            dataQa: 'participantsAges29andOver',
            label: t([
              'views',
              'form',
              'appDetails',
              'participants',
              'ages29andOver',
              'label'
            ]),
            value: p.form.participants.ages29andOver
          },
          {
            dataQa: 'participantsTotal',
            label: t([
              'views',
              'form',
              'appDetails',
              'participants',
              'total',
              'label'
            ]),
            value: total(p.form.participants)
          }
        ]}
      />
    </Section>
  )
}

const total = (x: AgeDistribution) =>
  x.ages7to20 + x.ages21to28 + x.ages29andOver
